// Палитра цвета текста и выделения в markdown-полях.
//
// В markdown цвет хранится тегами с ключом из палитры, а не произвольным CSS:
//   <span data-color="red">текст</span>   — цвет текста
//   <mark data-bg="yellow">текст</mark>   — выделение фоном
// Просмотр пропускает только эти теги и только ключи отсюда; оттенки для
// светлой и тёмной темы задаёт CSS (apps/web markdown-field.css).
// `hex` нужен выгрузке в Jira: `{color:#hex}текст{color}`.
export const MARKDOWN_TEXT_COLORS = [
    { key: 'gray', label: 'Серый', hex: '#6b778c' },
    { key: 'red', label: 'Красный', hex: '#de350b' },
    { key: 'orange', label: 'Оранжевый', hex: '#ff8b00' },
    { key: 'green', label: 'Зелёный', hex: '#00875a' },
    { key: 'blue', label: 'Синий', hex: '#0052cc' },
    { key: 'purple', label: 'Фиолетовый', hex: '#5243aa' },
];
export const MARKDOWN_HIGHLIGHT_COLORS = [
    { key: 'yellow', label: 'Жёлтый', hex: '#fff0b3' },
    { key: 'green', label: 'Зелёный', hex: '#e3fcef' },
    { key: 'blue', label: 'Голубой', hex: '#deebff' },
    { key: 'red', label: 'Розовый', hex: '#ffebe6' },
    { key: 'purple', label: 'Сиреневый', hex: '#eae6ff' },
    { key: 'gray', label: 'Серый', hex: '#ebecf0' },
];
export function isMarkdownTextColor(key) {
    return typeof key === 'string' && MARKDOWN_TEXT_COLORS.some((c) => c.key === key);
}
export function isMarkdownHighlightColor(key) {
    return typeof key === 'string' && MARKDOWN_HIGHLIGHT_COLORS.some((c) => c.key === key);
}
